import { api } from "../../common/config/api";

export const BONUS_URL = {
   getBonuses: `${api.withAPI}/v1/customerGroup`,
   save: `${api.withAPI}/v1/customerGroup`,
   change: `${api.withAPI}/v1/customerGroup`,
   delete: `${api.withAPI}/v1/customerGroup`
}
